'use strict';

/* globals define, socket, app, ajaxify, $, config */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/organizations/settings', [
	'coverPhoto',
	'pictureCropper',
	'components',
	'translator',
	RELATIVE_PATH_TRIMMED + '/organizations/details',
	'alerts'
], function (coverPhoto, pictureCropper, components, translator, organizationDetails, alerts) {
	var	OrganizationSettings = {};

	OrganizationSettings.init = function () {
		initColorPicker();
		prepareSaveSettings();
		organizationDetails.init();
	};

	function initColorPicker() {
		var settingsFormEl = components.get('organization/settings');
		var colorBtn = settingsFormEl.find('[data-action="organization-color-select"]');
		var colorValueEl = settingsFormEl.find('[name="organizationColor"]');

		colorBtn.css('background-color', colorValueEl.val() || getDefaultGroupColor());

		// Add color picker to settings form
		colorBtn.ColorPicker({
			color: colorValueEl.val() || getDefaultGroupColor(),
			onChange: function (hsb, hex) {
				colorValueEl.val('#' + hex);
				colorBtn.css('background-color', '#' + hex);

				setGroupColorToTheme('#' + hex);
			},
			onShow: function (colpkr) {
				$(colpkr).css('z-index', 1051);
			},
		});
	}

	function getDefaultGroupColor() {
		return '#333451';
	}

	function setGroupColorToTheme(organizationColor) {
		var selectors = ['#header', '#new_topic', '.groups .card-header.ch-alt'];

		$.each(selectors, function (index, value) {
			$(value).css('background-color', organizationColor);
		});
	}

	function prepareSaveSettings() {
		var settingsFormEl = components.get('organization/settings');

		settingsFormEl.find('[data-action="update"]').on('click', function () {
			var name = settingsFormEl.find('[name="name"]').val();
			var description = settingsFormEl.find('[name="description"]').val();
			var colorValue = settingsFormEl.find('[name="organizationColor"]').val();

			socket.emit('plugins.organizations.update', {
				id: ajaxify.data.organization.id,
				name: name,
				description: description,
				organizationColor: colorValue,
			}, function (err) {
				if (err) {
					return alerts.error(err.message);
				}

				app.alertSuccess('Changed');
			});

			return false;
		});
	}

	return OrganizationSettings;
});
